import { render, staticRenderFns } from "./TransferSaveFormSkeleton.vue?vue&type=template&id=49ab05e3&"
import script from "./TransferSaveFormSkeleton.vue?vue&type=script&lang=js&"
export * from "./TransferSaveFormSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports